import { render } from "./GoodsListCate2.vue?vue&type=template&id=7ab028c4"
import script from "./GoodsListCate2.vue?vue&type=script&lang=js"
export * from "./GoodsListCate2.vue?vue&type=script&lang=js"

import "./GoodsListCate2.vue?vue&type=style&index=0&id=7ab028c4&lang=scss"

import exportComponent from "E:\\Project\\UGit\\heronlink\\web\\pc\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__